export const GlobalsUseTaskAutoRedirect = "useTaskAutoRedirect";
export const GlobalUseXStateViz = "useXStateViz";
export const GlobalUseSentrySampleRate = "useSentrySampleRate";
export const LastPandoraTemplates = "lastPandoraTemplates";
